<p-dialog [(visible)]="display" [modal]="true"
[style]="{width: '60vw'}" styleClass="no-padding" (onHide)="close()" [showHeader]="false">
    <div class="card">
        <div class="p-d-flex">
            <p-menu styleClass="step-menu" [model]="items"></p-menu>
            <div class="card w-100">

              <form [formGroup]="customerProfileForm">
                <ng-container formGroupName="profileInfo" *ngIf="activePage == 1">
                    <h5>Determine profile needs</h5>
                    <p>Register your customer profile for US A2P Messaging. Get started by providing some information about your US A2P Messaging use case. </p>
                    <label><b><span style="color: red;">*</span>Is the business entity you’re registering located in the US and/or Canada?</b></label>


                  <div class="p-field-radiobutton p-mb-0">
                        <p-radioButton name="locate_in_usa" [value]="true" formControlName="locate_in_usa" inputId="locate1"></p-radioButton>
                        <label for="locate1">Yes</label>
                    </div>
                    <div class="p-field-radiobutton p-mb-0">
                        <p-radioButton name="locate_in_usa" [value]="false" formControlName="locate_in_usa" inputId="locate2"></p-radioButton>
                        <label for="locate2">No</label>
                    </div>

                  <ng-container *ngIf="customerFormValue('profileInfo.locate_in_usa')">
                        <div class="p-p-3" style="color: rgb(0, 20, 137);">
                            <h6>
                                <span class="pi pi-info-circle"></span>
                                Notice for US or Canadian customers with Tax ID!
                            </h6>
                            <p>US or Canadian customers who have a Tax ID need to register for a Low Volume Standard or Standard brand to send messages to the US.</p>
                            <p>US or Canadian customers who do not have a tax ID, need to register for a Sole Proprietor brand to send messages to the US.</p>
                        </div>
                        <label><b><span style="color: red;">*</span
                            >Does the business you’re registering have a tax ID (Ex. US EIN)?</b>
                            <div class="font-light">You can find your US EIN on your W2 or W9.</div>
                        </label>


                        <div class="p-field-radiobutton p-mb-0">
                            <p-radioButton name="has_tax_id" [value]="true" formControlName="has_tax_id" inputId="taxID1"></p-radioButton>
                            <label for="taxID1">Yes, the business I’m registering has a tax ID</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <p-radioButton name="has_tax_id" [value]="false" formControlName="has_tax_id" inputId="taxID2"></p-radioButton>
                            <label for="taxID2">No, the business I’m registering does not have a tax ID</label>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="customerFormValue('profileInfo.locate_in_usa') === false ||
                    (customerFormValue('profileInfo.locate_in_usa') === true && customerFormValue('profileInfo.has_tax_id') === true) ||
                    (customerFormValue('profileInfo.locate_in_usa') === true && customerFormValue('profileInfo.has_tax_id') === false)">
                        <div class="bg-purple p-p-3 p-my-3">
                            <h6>Based on the answers you provided, you are eligible for creating a Secondary customer profile</h6>
                            <p>Required for Standard Brand and Low Volume Standard Brand Registration - don't worry, we'll help you select your exact Brand type later in the process. Send messages across one or more campaign use cases
                            , with throughput (MPS) and messaging daily limits based on the brand’s TCR Trust Score. Requires additional fees
                            during brand and campaign use case registration.</p>
                        </div>
                        <label><b>Please confirm you meet these requirements</b></label>
                        <div class="p-grid border-bottom">
                            <div class="p-col-6">
                                <div>You have a tax ID</div>
                                <div class="font-light">Such as a US EIN</div>
                            </div>
                            <div class="p-col-6">
                                <span class="pi pi-check" style="color: #22c55e;"
                                *ngIf="customerFormValue('profileInfo.locate_in_usa') === false ||
                                (customerFormValue('profileInfo.locate_in_usa') === true && customerFormValue('profileInfo.has_tax_id') === true)"></span>
                                <span class="pi pi-times" style="color: red;"
                                *ngIf="customerFormValue('profileInfo.locate_in_usa') === true && customerFormValue('profileInfo.has_tax_id') === false"></span>
                            </div>
                        </div>
                        <div class="p-grid border-bottom p-mt-1" *ngIf="customerFormValue('profileInfo.has_tax_id') === false">
                            <div class="p-col-6">
                                <div>You are located in the US or Canada</div>
                            </div>
                            <div class="p-col-6">
                                <div>Yes</div>
                            </div>
                        </div>
                        <label><b>You will receive the following messaging capabilities</b></label>
                        <ng-container *ngIf="customerFormValue('profileInfo.locate_in_usa') === false ||
                                (customerFormValue('profileInfo.locate_in_usa') === true && customerFormValue('profileInfo.has_tax_id') === true)">
                            <div class="p-grid border-bottom">
                                <div class="p-col-6">
                                    <div>Max daily message volume</div>
                                </div>
                                <div class="p-col-6">
                                    <div>3,000+ segments per day, depending on Trust Score</div>
                                </div>
                            </div>
                            <div class="p-grid border-bottom p-mt-1">
                                <div class="p-col-6">
                                    <div>Max throughput</div>
                                </div>
                                <div class="p-col-6">
                                    <div>Depends on Trust Score</div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="customerFormValue('profileInfo.locate_in_usa') === true && customerFormValue('profileInfo.has_tax_id') === false">
                            <div class="p-grid border-bottom">
                                <div class="p-col-6">
                                    <div>Max daily message volume</div>
                                </div>
                                <div class="p-col-6">
                                    <div>3,000 segments per day</div>
                                </div>
                            </div>
                            <div class="p-grid border-bottom p-mt-1">
                                <div class="p-col-6">
                                    <div>Max throughput</div>
                                </div>
                                <div class="p-col-6">
                                    <div>1 message segment per second</div>
                                </div>
                            </div>
                            <div class="p-grid border-bottom p-mt-1">
                                <div class="p-col-6">
                                    <div>One-time Brand Registration</div>
                                </div>
                                <div class="p-col-6">
                                    <div>$4</div>
                                </div>
                            </div>
                        </ng-container>
                        <label><b>Fees</b></label>
                        <div class="p-grid border-bottom">
                            <div class="p-col-6">
                                <div>One-time Brand Registration</div>
                            </div>
                            <div class="p-col-6">
                                <div *ngIf="!customerFormValue('profileInfo.locate_in_usa')">3,000+ segments per day, depending on Trust Score</div>
                                <div *ngIf="customerFormValue('profileInfo.locate_in_usa') && customerFormValue('profileInfo.has_tax_id')">$4 - $44</div>
                                <div *ngIf="customerFormValue('profileInfo.locate_in_usa') && !customerFormValue('profileInfo.has_tax_id')">-</div>
                            </div>
                        </div>
                        <div class="p-grid border-bottom  p-mt-1">
                            <div class="p-col-6">
                                <div>One-time Campaign Vetting Fee</div>
                                <div class="font-light">Additional fees apply if Campaign is resubmitted upon initial failure</div>
                            </div>
                            <div class="p-col-6">
                                <div>$15 per Campaign</div>
                            </div>
                        </div>
                        <div class="p-grid border-bottom  p-mt-1">
                            <div class="p-col-6">
                                <div>Monthly Campaign Fee</div>
                            </div>
                            <div class="p-col-6">
                                <div *ngIf="customerFormValue('profileInfo.locate_in_usa') === false ||
                                (customerFormValue('profileInfo.locate_in_usa') === true && customerFormValue('profileInfo.has_tax_id') === true)">$1.50 - $10 per Campaign</div>
                                <div *ngIf="customerFormValue('profileInfo.locate_in_usa') === true && customerFormValue('profileInfo.has_tax_id') === false">$2 per Campaign</div>
                            </div>
                        </div>
                        <label><b>Information needed for registration</b></label>
                        <div class="p-grid border-bottom">
                            <div class="p-col-6">
                                <div>Information you need to submit</div>
                            </div>
                            <div class="p-col-6" *ngIf="customerFormValue('profileInfo.locate_in_usa') === false ||
                                (customerFormValue('profileInfo.locate_in_usa') === true && customerFormValue('profileInfo.has_tax_id') === true)">
                                <div>Business information, Business registration ID such as US EIN, Contact information, Business reason to use messaging and sample messages</div>
                            </div>
                            <div class="p-col-6" *ngIf="customerFormValue('profileInfo.locate_in_usa') === true && customerFormValue('profileInfo.has_tax_id') === false">
                                <div>Brand name, first name, last name, email address, business phone number, mobile phone number and physical address (Only valid addresses and mobile phone numbers in the U.S. and Canada will be accepted) Access to mobile device to complete OTP verification</div>
                            </div>
                        </div>

                        <ng-container *ngIf="customerFormValue('profileInfo.locate_in_usa') === false ||
                                (customerFormValue('profileInfo.locate_in_usa') === true && customerFormValue('profileInfo.has_tax_id') === true)">
                            <label><b><span style="color: red;">*</span>Would you like to register a Secondary customer profile?</b></label>
                            <div class="p-field-radiobutton p-mb-0">
                                <p-radioButton name="secondary_customer" [value]="true" formControlName="secondary_customer" inputId="secondary1"></p-radioButton>
                                <label for="secondary1">Yes, I would like to register as a Secondary customer profile</label>
                            </div>
                            <div class="p-field-radiobutton p-mb-0">
                                <p-radioButton name="secondary_customer" [value]="false" formControlName="secondary_customer" inputId="secondary2"></p-radioButton>
                                <label for="secondary2">No, I would not like to register as a Secondary customer profile</label>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="customerFormValue('profileInfo.locate_in_usa') === true && customerFormValue('profileInfo.has_tax_id') === false">
                            <label><b><span style="color: red;">*</span>Would you like to register for a Sole Proprietor package?</b></label>
                            <div class="p-field-radiobutton p-mb-0">
                                <p-radioButton name="sole_proprietor" [value]="true" formControlName="sole_proprietor" inputId="sole1"></p-radioButton>
                                <label for="sole1">Yes, I would like to register as a Secondary customer profile</label>
                            </div>
                            <div class="p-field-radiobutton p-mb-0">
                                <p-radioButton name="sole_proprietor" [value]="false" formControlName="sole_proprietor" inputId="sole2"></p-radioButton>
                                <label for="sole2">No, I would not like to register as a Secondary customer profile</label>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <ng-container formGroupName="businessDetails" *ngIf="(activePage==2 && !isEditInfo) || (activePage==5 && isEditInfo)">
                    <h5>Create Customer Profile</h5>
                    <div class="bg-blue p-p-3 p-my-3">
                        <h6>These details are important for your messaging limits!</h6>
                        <p>Twilio will submit information from this Customer Profile to The Campaign Registry (TCR)
                        during A2P Brand registration. Based on this information, TCR generates a trust score which determines your A2P messaging limits.
                        To get the highest possible messaging limits, please create this profile with the details that exactly match those in your business registration documents.
                        If there are any differences for example, in the business name or address your messaging limits will be lower.</p>
                    </div>
                    <label><b><span style="color: red;">*</span>Legal business name</b></label>
                    <input type="text" pInputText formControlName="business_name" />
                    <p>If you're registering a US entity, please enter the exact legal business name as registered with the EIN, which can be found on the CP 575 EIN Confirmation Letter.</p>

                    <label><b><span style="color: red;">*</span>Business Identity</b></label>
                    <div class="p-field-radiobutton p-mb-0">
                        <p-radioButton name="business_identity" value="direct_customer" formControlName="business_identity" inputId="identity1"></p-radioButton>
                        <label for="identity1">
                            Direct Customer
                            <div class="font-light">My business uses Twilio to communicate internally or with our customers</div>
                        </label>
                    </div>
                    <div class="p-field-radiobutton p-mb-0">
                        <p-radioButton name="business_identity" value="isv_reseller_or_partner" formControlName="business_identity" inputId="identity2"></p-radioButton>
                        <label for="identity2">ISV, Reseller, or Partner
                            <div class="font-light">My business uses Twilio in a product that I sell to my customers</div>
                        </label>
                    </div>
                    <div class="p-field-radiobutton p-mb-0">
                        <p-radioButton name="business_identity" value="unknown" formControlName="business_identity" inputId="identity3"></p-radioButton>
                        <label for="identity3">I don't know</label>
                    </div>

                  <label><b><span style="color: red;">*</span>Business Type</b></label>
                  <p-dropdown [options]="businessTypes" formControlName="business_type" optionValue="value" placeholder="Select"
                              optionLabel="name" [showClear]="true" appendTo="body"></p-dropdown>

                    <ng-container *ngIf="customerFormValue('profileInfo.secondary_customer')">

                      <label><b><span style="color: red;">*</span>Business Registration ID Type</b>
                        <span class="pi pi-info-circle p-ml-2" pTooltip="VAT number is recommended for companies in the countries not listed here" tooltipPosition="top"></span>
                      </label>
                      <p-dropdown [options]="businessIDTypes" formControlName="business_registration_identifier" placeholder="Select"
                                  optionLabel="name" optionValue="value" [showClear]="true" appendTo="body" (onChange)="formatNumbe()"></p-dropdown>

                      <label><b><span style="color: red;">*</span>Business Registration Number</b></label>
                      <input type="text" pInputText [placeholder]="numberFormat" formControlName="business_registration_number" />
                      <div class="font-light">{{numberMsg}}</div>
                    </ng-container>

                    <label><b><span style="color: red;">*</span>Business Industry</b></label>
                    <p-dropdown [options]="industries" formControlName="business_industry" optionValue="value" placeholder="Select"
                    optionLabel="name" [showClear]="true" appendTo="body"></p-dropdown>


                    <label><b><span style="color: red;">*</span>Website Url</b></label>
                    <input type="text" pInputText formControlName="website_url" placeholder="https://example.com" />
                    <div class="font-light">The provided website should be reflective of the registered brand and accessible.</div>

                    <label><b><span style="color: red;">*</span>Business Regions of Operations</b></label>
                    <div class="p-grid">
                        <div *ngFor="let region of regions;let i = index" class="p-col-4 p-field-checkbox p-mb-0 p-pb-0">
                            <p-checkbox name="region"  [value]="region"
                            [formControl]="customerBusinessRegionsControl" [inputId]="region"></p-checkbox>
                            <label [for]="region">{{region}}</label>
                        </div>
                      <!--
                       <div *ngFor="let region of regions;let i = index" class="p-col-4 p-field-checkbox p-mb-0 p-pb-0">
                            <p-radioButton name="business_regions_of_operation"  [value]="region"
                            formControlName="business_regions_of_operation" [inputId]="region"></p-radioButton>
                            <label [for]="region">{{region}}</label>
                        </div>-->
                    </div>
                </ng-container>

                <ng-container formGroupName="businessAddress" *ngIf="(activePage==3 && !isEditAddress) || (activePage==5 && isEditAddress)">
                    <h5>Business Address</h5>
                    <div class="p-field-radiobutton p-mb-0">
                        <p-radioButton name="addressType" value="new" formControlName="addressType" inputId="address1"></p-radioButton>
                        <label for="address1">Enter new address</label>
                    </div>
                    <div class="p-field-radiobutton p-mb-0">
                        <p-radioButton name="addressType" value="existing" formControlName="addressType" inputId="address2"></p-radioButton>
                        <label for="address2">Select from existing addresses</label>
                    </div>

                    <ng-container *ngIf="customerFormValue('businessAddress.addressType') === 'new'">
                        <label><b><span style="color: red;">*</span>Country</b></label>
                        <p-dropdown [options]="countries" optionValue="value" formControlName='isoCountry' placeholder="Select"
                        optionLabel="name" [showClear]="true" appendTo="body"></p-dropdown>

                        <label><b><span style="color: red;">*</span>Street Address</b></label>
                        <input type="text" pInputText formControlName="street" />
                        <div class="font-light">Enter the first line of business address as it appears in the EIN listing.</div>

                      <label><b>Street Address Line 2</b></label>
                        <input type="text" pInputText formControlName="streetSecondary" />

                      <label><b><span style="color: red;">*</span>City</b></label>
                        <input type="text" pInputText formControlName="city" />
                        <div class="font-light">Enter the city name as it appears in the EIN listing.</div>

                        <label><b><span style="color: red;">*</span>State/Province/Region</b></label>
                        <input type="text" pInputText formControlName="region" />
                        <div class="font-light">Enter the state/province/region as it appears in the EIN listing.</div>

                        <label><b><span style="color: red;">*</span>Postal/Zip code</b></label>
                        <input type="text" pInputText formControlName="postalCode"/>
                        <div class="font-light">Enter the postal code as it appears in the EIN listing.</div>
                    </ng-container>

                  <!-- Existing Address -->
                    <ng-container *ngIf="customerFormValue('businessAddress.addressType') === 'existing'">
                        <p-table [value]="addresses" [(selection)]="selectedAddress" dataKey="id"
                        responsiveLayout="scroll" class="fix-width">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 3rem"></th>
                                    <th>Country</th>
                                    <th>State</th>
                                    <th>City</th>
                                    <th>Address 1</th>
                                    <th>Address 2</th>
                                    <th>Zipcode</th>
                                    <th>Address SID</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-product>
                                <tr>
                                    <td>
                                        <p-tableRadioButton [value]="product"></p-tableRadioButton>
                                    </td>
                                    <td>{{product.country}}</td>
                                    <td>{{product.state}}</td>
                                    <td>{{product.city}}</td>
                                    <td>{{product.address1}}</td>
                                    <td>{{product.address2}}</td>
                                    <td>{{product.zipcode}}</td>
                                    <td style="word-break: break-all;">{{product.sid}}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="(activePage==4 && !isEditAuth) || (activePage==5 && isEditAuth)">

                  <h5>Notification Settings</h5>
                  <div class="bg-blue p-p-3 p-my-3">
                      <h6>To notify multiple recipients, consider using a distribution email address.</h6>
                      <p>We will use the provided email address to notify recipients about the status of this Customer Profile. This email address will not be subscribed to any marketing emails.</p>
                  </div>
                  <ng-container formGroupName="notificationSetting">
                    <label><b><span style="color: red;">*</span>Email address</b></label>
                    <input type="text" pInputText formControlName="email" placeholder="email@company.com" class="p-mb-3" />
                  </ng-container>

                  <ng-container formGroupName="contactInfo">
                    <ng-container formArrayName="representativeas">
                      <ng-container *ngFor="let group of authRepresentativeArray.controls; let i = index" [formGroupName]="i">
                        <h5 class="border-top p-pt-4">Authorized Representatives {{ i + 1}}</h5>
                        <p>Please provide information about the people who can be contacted about the information provided for this customer profile. They’ll only be contacted in case there are any issues with the submitted information.</p>

                        <label><b><span style="color: red;">*</span>First Name</b></label>
                        <input type="text" pInputText formControlName="first_name" placeholder="First Name" />

                        <label><b><span style="color: red;">*</span>Last Name</b></label>
                        <input type="text" pInputText formControlName="last_name" placeholder="Last Name" />

                        <label><b><span style="color: red;">*</span>Email</b></label>
                        <input type="text" pInputText formControlName="email" placeholder="email@company.com" />

                        <label><b><span style="color: red;">*</span>Business Title</b></label>
                        <input type="text" pInputText formControlName="business_title" placeholder="Senior Director" />

                        <label><b><span style="color: red;">*</span>Country Code</b></label>
                        <p-dropdown
                          placeholder="Select"
                          [options]="countries"
                          formControlName="country"
                          optionLabel="name"
                          optionValue="value"
                          [showClear]="true" appendTo="body">
                        </p-dropdown>

                        <label><b><span style="color: red;">*</span>Phone Number</b></label>
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon">{{countryCode}}</span>
                          <input type="text" pInputText formControlName="phone_number" placeholder="1234567890">
                        </div>

                        <label><b><span style="color: red;">*</span>Job Position</b></label>
                        <p-dropdown placeholder="Select" [options]="jobPositions" optionValue="value" formControlName="job_position"
                                    optionLabel="name" [showClear]="true" appendTo="body"></p-dropdown>
                      </ng-container>
                    </ng-container>

                    <label><b>Do you want to add another authorized representative? (Optional)</b></label>
                    <div class="font-light">This authorized representative will potentially be contacted if the first one does not respond.</div>
                    <div class="p-field-radiobutton p-mb-0">
                      <p-radioButton name="anotherAuth" value="authYes" formControlName="anotherAuth" (onClick)="addAuthRepresentativeFormGroup()" inputId="auth1"></p-radioButton>
                      <label for="auth1">Yes</label>
                    </div>
                    <div class="p-field-radiobutton p-mb-0 p-pb-2 border-bottom">
                      <p-radioButton name="anotherAuth" value="authNo" formControlName="anotherAuth" (click)="removeAuthRepresentativeFormGroup()" inputId="auth2"></p-radioButton>
                      <label for="auth2">No</label>
                    </div>

                    <div class="p-field-checkbox bg-grey p-p-2 p-mt-3">
                      <p-checkbox formControlName="confirm_contacted_by_twilio" [binary]="true" inputId="binary"></p-checkbox>
                      <label for="binary">I confirm that my nominated authorized representatives agree to be contacted by Twilio.</label>
                    </div>
                  </ng-container>

                </ng-container>


                <ng-container *ngIf="activePage == 5">
                    <ng-container *ngIf="!isEditInfo && !isEditAddress && !isEditAuth">
                        <p-card class="review-card">
                            <div class="p-d-flex p-jc-between">
                                <h5>Business information</h5>
                                <span class="btnBars" (click)="isEditInfo=true;">
                                    <i class="pi pi-pencil"></i>
                                </span>
                            </div>
                            <div class="p-grid">
                                <div class="p-col-4">
                                    <label><b>Business type</b></label>
                                    <p>{{ customerFormValue('businessDetails.business_type') ?? '-' }}</p>
                                </div>
                                <div class="p-col-4">
                                    <label><b>Business registration number</b></label>
                                    <p>{{ customerFormValue('businessDetails.business_registration_number') ?? '-' }}</p>
                                </div>
                                <div class="p-col-4">
                                    <label><b>Business name</b></label>
                                    <p>{{ customerFormValue('businessDetails.business_name') ?? '-' }}</p>
                                </div>
                                <div class="p-col-4">
                                    <label><b>Business registration id type</b></label>
                                    <p>{{ customerFormValue('businessDetails.business_registration_identifier') ?? '-' }}</p>
                                </div>
                                <div class="p-col-4">
                                    <label><b>Business identity</b></label>
                                    <p>{{ customerFormValue('businessDetails.business_identity') ?? '-' }}</p>
                                </div>
                                <div class="p-col-4">
                                    <label><b>Business industry</b></label>
                                    <p>{{ customerFormValue('businessDetails.business_industry') ?? '-' }}</p>
                                </div>
                                <div class="p-col-4">
                                    <label><b>Website url</b></label>
                                    <p>{{ customerFormValue('businessDetails.website_url') ?? '-' }}</p>
                                </div>
                                <div class="p-col-4">
                                    <label><b>Business regions of operations</b></label>
                                    <p>{{ customerFormValue('businessDetails.business_regions_of_operation') ?? '-' }}</p>
                                </div>
                            </div>
                        </p-card>
                        <p-card class="review-card">
                            <div class="p-d-flex p-jc-between">
                                <h5>Business address</h5>
                                <span class="btnBars" (click)="isEditAddress=true;">
                                    <i class="pi pi-pencil"></i>
                                </span>
                            </div>
                            <div class="p-grid">
                                <div class="p-col-4">
                                    <label><b>Country</b></label>
                                    <p>{{ customerFormValue('businessAddress.isoCountry') ?? '-' }}</p>
                                </div>
                                <div class="p-col-4">
                                    <label><b>Street address</b></label>
                                    <p>{{ customerFormValue('businessAddress.street') ?? '-' }}</p>
                                </div>
                                <div class="p-col-4">
                                    <label><b>City</b></label>
                                    <p>{{ customerFormValue('businessAddress.city') ?? '-' }}</p>
                                </div>
                                <div class="p-col-4">
                                    <label><b>State province region</b></label>
                                    <p>{{ customerFormValue('businessAddress.region') ?? '-' }}</p>
                                </div>
                                <div class="p-col-4">
                                    <label><b>Postal zip code</b></label>
                                    <p>{{ customerFormValue('businessAddress.postalCode') ?? '-' }}</p>
                                </div>
                            </div>
                        </p-card>
                        <p-card class="review-card">
                            <div class="p-d-flex p-jc-between">
                                <h5>Contact Information</h5>
                                <span class="btnBars" (click)="isEditAuth=true;">
                                    <i class="pi pi-pencil"></i>
                                </span>
                            </div>

                          <ng-container *ngFor="let group of authRepresentativeArray.controls; let i = index">
                            <div class="p-grid p-pt-3">
                              <div class="p-col-12">
                                <h5>Authorized representative #{{i+1}}</h5>
                              </div>
                              <div class="p-col-4">
                                <label><b>First name</b></label>
                                <p>{{ group.get('first_name').value ?? '-' }}</p>
                              </div>
                              <div class="p-col-4">
                                <label><b>Last name</b></label>
                                <p>{{ group.get('last_name').value ?? '-' }}</p>
                              </div>
                              <div class="p-col-4">
                                <label><b>Email</b></label>
                                <p>{{ group.get('email').value ?? '-' }}</p>
                              </div>

                              <div class="p-col-4">
                                <label><b>Business title</b></label>
                                <p>{{ group.get('business_title').value ?? '-' }}</p>
                              </div>
                              <div class="p-col-4">
                                <label><b>Phone number</b></label>
                                <p>{{ group.get('phone_number').value ?? '-' }}</p>
                              </div>
                              <div class="p-col-4">
                                <label><b>Job position</b></label>
                                <p>{{ group.get('job_position').value ?? '-' }}</p>
                              </div>
                            </div>
                          </ng-container>

                          <div class="p-grid">
                            <div class="p-col-4">
                              <label><b>Notification email address</b></label>
                              <p>{{ customerFormValue('notificationSetting.email') ?? '-' }}</p>
                            </div>
                          </div>

                        </p-card>
                        <div class="p-field-checkbox bg-grey p-p-2 p-mt-2">
                            <p-checkbox formControlName="accept_twilio_privacy"  [binary]="true" inputId="binary"></p-checkbox>
                            <label for="binary">I declare that the information provided is accurate. I acknowledge that Twilio will be processing the information provided for the purposes of identity verification, and that Twilio reserves the right to retain the Customer Profile information after account closure in the case of a traceback from a regulatory authority or equivalent.<br><br>Twilio will process your personal data according to the  Twilio Privacy Statement</label>
                        </div>
                    </ng-container>
                </ng-container>

              </form>

                <ng-container *ngIf="activePage == 6 && !isSubmitBrand">
                    <h5>Submit Brand</h5>
                    <p>We’ll register the brand on your behalf with The Campaign Registry(TCR)
                    , the third party that handles the process for all carriers. There is a one-time fee of $4 to register a brand. Once the Brand and Campaign information is approved, your business will be able to send up to 3,000 segments per day.</p>
                    <label><b><span style="color: red;">*</span>Company Type</b></label>
                    <div class="font-light">Non-US nonprofits and governments should register as a private or public company.</div>
                    <div class="p-d-flex">
                        <div class="p-field-radiobutton p-mb-0 p-pb-2 p-mr-3">
                            <p-radioButton name="companyType" value="private" [(ngModel)]="companyType" inputId="type1"></p-radioButton>
                            <label for="type1">Private</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0 p-pb-2 p-mr-3">
                            <p-radioButton name="companyType" value="public" [(ngModel)]="companyType" inputId="type2"></p-radioButton>
                            <label for="type2">Public</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0 p-pb-2 p-mr-3">
                            <p-radioButton name="companyType" value="nonpofit" [(ngModel)]="companyType" inputId="type3"></p-radioButton>
                            <label for="type3">US Non Profit</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0 p-pb-2 p-mr-3">
                            <p-radioButton name="companyType" value="government" [(ngModel)]="companyType" inputId="type4"></p-radioButton>
                            <label for="type4">US Government</label>
                        </div>
                    </div>
                    <ng-container *ngIf="companyType == 'public'">
                        <label><b><span style="color: red;">*</span>Company Stock Ticker Symbol</b></label>
                        <input type="text" pInputText />
                        <label><b>Stock exchange</b></label>
                        <p-dropdown placeholder="Select" optionLabel="name" appendTo="body"></p-dropdown>
                    </ng-container>
                    <ng-container *ngIf="companyType == 'nonpofit'">
                        <label><b><span style="color: red;">*</span>Are you a 527 Political Organization</b></label>
                        <div class="p-d-flex">
                            <div class="p-field-radiobutton p-mb-0 p-pb-2 p-mr-3">
                                <p-radioButton name="isPolitical" value="politicalYes" [(ngModel)]="isPolitical" inputId="political1"></p-radioButton>
                                <label for="political1">Yes</label>
                            </div>
                            <div class="p-field-radiobutton p-mb-0 p-pb-2 p-mr-3">
                                <p-radioButton name="isPolitical" value="politicalNo" [(ngModel)]="isPolitical" inputId="political2"></p-radioButton>
                                <label for="political2">No</label>
                            </div>
                        </div>
                        <div class="bg-blue p-p-3 p-mt-2 p-mb-3">
                            <div class="p-d-flex">
                                <span class="pi pi-info-circle"></span>
                                <div class="p-ml-2">
                                    Nonprofits and government entities must register as Standard Brands. This ensures additional vetting for these organizations to unlock reduced carrier fees and/or increased messaging throughput.
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="companyType == 'government'">
                        <div class="bg-blue p-p-3 p-my-3">
                            <div class="p-d-flex">
                                <span class="pi pi-info-circle"></span>
                                <div class="p-ml-2">
                                    Nonprofits and government entities must register as Standard Brands. This ensures additional vetting for these organizations to unlock reduced carrier fees and/or increased messaging throughput.
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <label><b><span style="color: red;">*</span>What type of brand do you need?</b></label>
                    <div class="p-field-radiobutton p-mb-0 p-pb-2 p-mr-3">
                        <p-radioButton name="brandType" value="Low" [(ngModel)]="brandType" inputId="type1"></p-radioButton>
                        <label for="type1">Low-Volume Standard Brand<span class="font-light p-ml-2">$4 one-time fee</span></label>
                    </div>
                    <div class="font-light p-ml-5">Recommended for customers sending fewer than 6,000 message segments per day to the US (2,000 message segments per day to T-Mobile)</div>
                    <div class="p-field-radiobutton p-mb-0 p-pb-2 p-mr-3">
                        <p-radioButton name="brandType" value="Standard" [(ngModel)]="brandType" inputId="type2"></p-radioButton>
                        <label for="type2">Standard<span class="font-light p-ml-2">$44 one-time fee</span></label>
                    </div>
                    <div class="font-light p-ml-5">Recommended for customers sending messages at scale. Your daily limit may fall between 6,000 and 600,000 message segments per day to the US (2,000 - 200,000 per day to T-Mobile). </div>
                    <div class="p-field-checkbox bg-grey p-p-2 p-mt-3">
                        <p-checkbox [(ngModel)]="correctCheck" [binary]="true" inputId="binary"></p-checkbox>
                        <label for="binary">I agree the above information is correct. I agree to a one-time <span *ngIf="brandType=='Standard'">$44</span><span *ngIf="brandType=='Low'">$4</span> A2P brand registration fee.</label>
                    </div>
                </ng-container>


                <ng-container *ngIf="activePage == 6 && isSubmitBrand">
                    <div class="p-d-flex p-jc-between">
                        <h5>{{businessName}}
                            <span class="p-ml-2 bg-blue" style="padding: 0.25rem 0.5rem;font-size: 10px;border-radius: 12px;">{{brandType}}</span>
                        </h5>
                        <span class="btnBars" style="color: red;">
                            <i class="pi pi-trash"></i>
                        </span>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-6">
                            <label><b>Registration status</b></label>
                            <div class="p-d-flex">
                                <span style="color: #22c55e;" class="fa fa-circle p-mr-2"></span>
                                Registered
                            </div>
                        </div>
                        <div class="p-col-6">
                            <label><b>Customer type</b></label>
                            <div>Private</div>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-6">
                            <label><b>Brand registration SID</b></label>
                            <div class="p-d-flex">
                                <span #regsid>BN3ee39840b5905e957fa9c3913547334d</span>
                                <span class="btnBars p-ml-1" (click)="copy(regsid)" style="margin-top: -0.5rem;">
                                    <i class="pi pi-copy"></i>
                                </span>
                            </div>
                        </div>
                        <div class="p-col-6">
                            <label><b>External Brand ID</b></label>
                            <div>B7LUVS1</div>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-6">
                            <label><b>Trust Hub A2P bundle SID</b></label>
                            <div class="p-d-flex">
                                <span #a2pid>BU303d56b7af3ccf6d921cf546a6e35e2d</span>
                                <span class="btnBars p-ml-1" (click)="copy(a2pid)" style="margin-top: -0.5rem;">
                                    <i class="pi pi-copy"></i>
                                </span>
                            </div>
                        </div>
                        <div class="p-col-6">
                            <label><b>Date created</b></label>
                            <div>11/16/2022, 9:58:32 AM</div>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-6">
                            <label><b>Connected Customer Profile SID</b></label>
                            <div class="p-d-flex">
                                <span #prosid>BU327ef299d2e3823a4b522b93ca2758cf</span>
                                <span class="btnBars p-ml-1" (click)="copy(prosid)" style="margin-top: -0.5rem;">
                                    <i class="pi pi-copy"></i>
                                </span>
                            </div>
                        </div>
                        <div class="p-col-6">
                            <label><b>Date updated</b></label>
                            <div>11/17/2022, 3:04:56 PM</div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="activePage == 7">
                    <h5>A2P Messaging Limits</h5>
                    <label><b>Messaging volume</b></label>
                    <p>If the connected business is listed in Russell 3000 index, campaigns connected to this brand will be able to send 200,000 outbound SMS segments and MMS daily to T-Mobile. (messages exceeding this limit will fail)</p>
                    <p>For non Russell 3000 entities, campaigns connected to this brand will be able to send 2,000 outbound SMS segments (and MMS) daily to T-Mobile. (messages exceeding this limit will fail)</p>
                </ng-container>

                <ng-container *ngIf="activePage == 8 && !isConfirm">
                    <h5>Create new A2P Campaign</h5>
                    <p>A Campaign represents your messaging use case with Twilio, for example, sending account notifications or conducting marketing. Every campaign is connected to a registered A2P Brand and a Messaging Service. Once successfully registered, you will be able to associate your 10DLC numbers with the connected Messaging Service to avail A2P Messaging benefits and avoid any carrier penalties for unregistered messaging.</p>

                    <label><b><span style="color: red;">*</span>A2P Brand</b></label>
                    <input type="text" pInputText [(ngModel)]="businessName" disabled />
                    <label><b><span style="color: red;">*</span>Available A2P Campaign use cases</b></label>
                    <p-dropdown [options]="cases" [(ngModel)]="selectedCaseValue" placeholder="Select" [group]="true"
                    (onChange)="showSelect(selectedCaseValue)" class="customDD">
                        <ng-template let-group pTemplate="group">
                            <div>{{group.label}}</div>
                        </ng-template>
                        <ng-template pTemplate="selectedItem">
                            <div *ngIf="selectedCase">
                                <div>{{selectedCase.label}}</div>
                            </div>
                        </ng-template>
                        <ng-template let-case pTemplate="item">
                            <div class="custom-item">
                                <div>{{case.label}} {{case.rate}}
                                    <span class="p-ml-2 bg-blue" style="padding: 0.25rem 0.5rem;font-size: 10px;border-radius: 12px;"
                                    *ngIf="case.value=='low-volume'">Recommended</span>
                                </div>
                                <div class="font-light">{{case.details}}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                    <div *ngIf="selectedParentCase?.value=='required1'" (click)="op.toggle($event)"
                    class="pointer p-mt-1" style="color: var(--primary-color);">Learn more</div>
                    <p-overlayPanel #op>
                        <ng-template pTemplate>
                            <h6>Campaign use case</h6>
                            <p>Use case that most closely resembles your campaign.</p>
                            <h6>Successful Example:</h6>
                            <p>2FA use case is selected for any authentication or account verification such as OTP.<br>(Use case matches campaign description and sample messages.)</p>
                            <h6>Failure Example:</h6>
                            <p>Higher Education is selected for any authentication or account verification such as OTP.<br>(Use case would not match intended use, campaign will be rejected.)</p>
                        </ng-template>
                    </p-overlayPanel>
                    <ng-container *ngIf="selectedParentCase?.value=='required2'">
                        <div class="bg-blue p-p-3 p-mt-3 p-mb-2" style="border-bottom: 2px solid #1a77f2;">
                            <div class="p-d-flex">
                                <span class="pi pi-info-circle"></span>
                                <div class="p-ml-2">
                                    <b>This campaign requires carrier approval.</b> You cannot send A2P-registered messages using this campaign until the carrier review is complete. We’ll notify you of their decision by email.
                                </div>
                            </div>
                        </div>
                        <a class="p-mb-3" style="color: var(--primary-color);"
                        href="https://support.twilio.com/hc/en-us/articles/1260801844470-List-of-campaign-use-case-types-for-A2P-10DLC-registration"
                        target="_blank">
                            Learn more about which campaign use case to select
                        </a>
                    </ng-container>
                    <label><b><span style="color: red;">*</span>Messaging Service</b></label>
                    <div>Campaign will be linked to selected Messaging Service. 10DLC Phone numbers can be added to the Messaging Service after Campaign has been created.</div>
                    <div class="p-field-radiobutton p-mb-0">
                        <p-radioButton name="messagingService" value="new" [(ngModel)]="messagingService" inputId="msg1"></p-radioButton>
                        <label for="msg1">
                            Create new Messaging Service
                            <div class="font-light">Messaging Service will be created automatically with Campaign registration.</div>
                        </label>
                    </div>
                    <div class="p-field-radiobutton p-mb-0">
                        <p-radioButton name="messagingService" value="existing" [(ngModel)]="messagingService" inputId="msg2"></p-radioButton>
                        <label for="msg2">Select existing Messaging Service</label>
                    </div>
                    <ng-container *ngIf="messagingService == 'existing'">
                        <label><b><span style="color: red;">*</span>Existing Messaging Service</b></label>
                        <p-autoComplete [(ngModel)]="selectedService" [suggestions]="filteredService"
                        (completeMethod)="filterService($event)" field="sid" [dropdown]="true"
                        placeholder="Search Messaging Service by Messaging Service SID(MGxxx)"
                        (onSelect)="checkService()">
                            <ng-template let-s pTemplate="item">
                                <div>{{s.name}}</div>
                                <div class="font-light" style="font-size: 10px;">{{s.sid}}</div>
                            </ng-template>
                        </p-autoComplete>
                    </ng-container>

                    <div class="bg-blue p-p-3 p-mt-2 p-mb-3">
                        <div class="p-d-flex">
                            <span class="pi pi-info-circle"></span>
                            <div class="p-ml-2">
                                <b>Please do not include any Personal Identifiable Information (PII) in Campaign registration fields</b>
                                <br>Publicly available information like brand names and phone numbers is acceptable.
                            </div>
                        </div>
                    </div>
                    <label><b><span style="color: red;">*</span>Campaign description</b></label>
                    <textarea rows="3" cols="30" pInputTextarea placeholder="Example: This campaign sends one-time passcodes to the end users when they try to log into our company's website."></textarea>
                    <div class="font-light">Describe what you will be using this campaign for.
                        <span class="pointer" style="color: var(--primary-color);" (click)="op2.toggle($event)">Learn more</span>
                    </div>
                    <p-overlayPanel #op2>
                        <ng-template pTemplate>
                            <h6>Campaign use case description</h6>
                            <p>Explanation of Campaign objective or purpose.</p>
                            <ul>
                                <li>If the Campaign pertains to financial services, please include "Direct Lending" in the Campaign description to avoid failure or rejection of this Campaign.</li>
                            </ul>
                            <h6 class="p-mb-0" style="font-size: 12px;">Successful Example:</h6>
                            <p>"This Campaign sends OTP for MFA challenges to login to an online portal to make changes to a user profile for security purposes. Customer confirms with an SMS when profile changes are made."
                                <br>(Campaign description matches sample message and sample message)
                            </p>
                            <h6 class="p-mb-0" style="font-size: 12px;">Failure Example:</h6>
                            <p>
                                "Blank"
                                <br>"This Campaign sends appointment information and confirmations to
                                <br>customer"
                            </p>
                        </ng-template>
                    </p-overlayPanel>
                    <label><b><span style="color: red;">*</span>Sample message #1</b></label>
                    <textarea rows="3" cols="30" pInputTextarea placeholder="Example: Your one-time passcode is 123456."></textarea>
                    <div class="font-light">Provide an example of a message that you will be sending with this campaign. This message sample will be used by carriers to help identify your traffic.
                        <span class="pointer" style="color: var(--primary-color);" (click)="op3.toggle($event)">Learn more</span>
                    </div>
                    <p-overlayPanel #op3>
                        <ng-template pTemplate>
                            <h6>Sample messages</h6>
                            <p>Sample messages should reflect actual messages to be sent under campaign.</p>
                            <ul>
                                <li>Do not use placeholder text for your sample messages</li>
                                <li>Use brackets to indicate templated fields in sample message</li>
                                <li>Consistency in sample message, use case, and campaign description</li>
                                <li>Provide Opt-out when applicable</li>
                            </ul>
                            <h6 class="p-mb-0" style="font-size: 12px;">Successful Example:</h6>
                            <p>"ACME 2FA Notice: Here is your one time password: 1234Call [phone-number] to report if this request was not made by you."</p>
                            <h6 class="p-mb-0" style="font-size: 12px;">Failure Example:</h6>
                            <p>
                                "You have an upcoming appointment"
                                <br>(Opt-out is not provided, campaign will be rejected.)
                            </p>
                        </ng-template>
                    </p-overlayPanel>
                    <label><b><span style="color: red;">*</span>Sample message #2</b></label>
                    <textarea rows="3" cols="30" pInputTextarea placeholder="Example: Your one-time passcode is 123456."></textarea>
                    <div class="font-light">Provide an example of a message that you will be sending with this campaign. This message sample will be used by carriers to help identify your traffic.</div>
                    <label><b>Message contents</b></label>
                    <div class="p-field-checkbox p-mb-0">
                        <p-checkbox name="contents" value="embedded" [(ngModel)]="selectedcontent" inputId="embedded"></p-checkbox>
                        <label for="embedded">Messages will include embedded links.</label>
                    </div>
                    <div class="p-field-checkbox">
                        <p-checkbox name="contents" value="phone" [(ngModel)]="selectedcontent" inputId="phone"></p-checkbox>
                        <label for="phone">Messages will include phone numbers.</label>
                    </div>
                    <div class="bg-blue p-p-3 p-mt-2 p-mb-3">
                        <div class="p-d-flex">
                            <span class="pi pi-info-circle"></span>
                            <div class="p-ml-2">
                                <h6>Did you know?</h6>
                                Most Campaigns that fail or are rejected are due to incorrect information being submitted in the "How do end-users consent to receive messages?" section below.
                                <span class="pointer" style="color: var(--primary-color);" (click)="successExample()">Learn more</span>
                            </div>
                        </div>
                    </div>
                    <label><b><span style="color: red;">*</span>How do end-users consent to receive messages? (40-2048 characters)</b></label>
                    <textarea rows="3" cols="30" pInputTextarea placeholder="Example: End users opt-in by visiting www.examplewebsite.com and adding their phone number. They then check a box agreeing to receive text messages from Example Brand. Opt-in occurs after end users create an accoutn; see screenshot of opt-in (www.example.com/screenshot-of-the-form-field). Additionally, end users can also opt-in by texting START to (111)222-3333 to opt in."></textarea>
                    <div class="font-light">This field should describe how end users opt-in to the campaign, therefore giving consent to the sender to receive their messages. If multiple opt-in methods can be used for the same campaign, they must all be listed.
                        <span class="pointer" style="color: var(--primary-color);" (click)="op4.toggle($event)">Learn more</span>
                    </div>
                    <p-overlayPanel #op4>
                        <ng-template pTemplate>
                            <h6>How do end-users consent to receive messages?</h6>
                            <p>This field should describe how and when consumers opt-in to the campaign, therefore giving consent to the sender to receive their messages. The call-to-action must be explicitly clear and inform consumers of the nature of the program. If multiple opt-in methods can be used for the same, list them all.</p>
                            <ul>
                                <li>Provide website where opt-in occurs.</li>
                                <li>List all opt-in methods.</li>
                                <li>Include an opt-in message if users can text.</li>
                                <li>If a website is provided, it must be accessible with privacy policy and terms.</li>
                                <li>If opt-in occurs behind a gated login or on paper, provide a hosted link of a screenshot or document of the opt-in.</li>
                            </ul>
                            <h6 class="p-mb-0" style="font-size: 12px;">Successful Example:</h6>
                            <p>"Customers provide opt-in specifically when enrolling into our website, or in person by requesting SMS capabilities within the store. Opt-in during website is a self-service process and occurs at acme.com/signup. By submitting, you authorize ACME to send text messages with offers and other information. Message/data rates apply. Consent is not a condition of purchase. [Link to terms and conditions]."</p>
                            <h6 class="p-mb-0" style="font-size: 12px;">Failure Example:</h6>
                            <p>
                                "Customers sign up"
                                <br>(Where and how the customer provides opt-in is unclear, campaign will be rejected.)
                            </p>
                        </ng-template>
                    </p-overlayPanel>
                    <label><b>Opt-in Keywords (max 255 characters)</b></label>
                    <input type="text" pInputText placeholder="Example: Subscribe, Start" />
                    <div class="font-light">If end users can text in a keyword (for example, “Subscribe”) to start receiving messages from your campaign, those keywords must be provided. If you do not support opt-in via text, please leave this blank.
                        <span class="pointer" style="color: var(--primary-color);" (click)="op5.toggle($event)">Learn more</span>
                    </div>
                    <p-overlayPanel #op5>
                        <ng-template pTemplate>
                            <h6>Opt-in Keywords</h6>
                            <p>List all keywords that allows users to opt-in</p>
                            <h6 class="p-mb-0" style="font-size: 12px;">Successful Example:</h6>
                            <p>"START, OPTIN, UNSTOP, IN"</p>
                            <h6 class="p-mb-0" style="font-size: 12px;">Failure Example:</h6>
                            <p>
                                "Blank"
                                <br>(Message flow indicates customers can opt-in through text but no opt-in keywords are provided, campaign will be rejected)
                            </p>
                        </ng-template>
                    </p-overlayPanel>
                    <label><b>Opt-in Message (20-320 characters)</b></label>
                    <textarea rows="3" cols="30" pInputTextarea placeholder="Example: Acme Corporation: You are now opted-in. For help, reply HELP. To opt-out, reply STOP."></textarea>
                    <div class="font-light">If end users can text in a keyword to start receiving messages from your campaign, the auto-reply messages sent to the end users must be provided. The opt-in response should include the Brand name, confirmation of opt-in enrollment to a recurring message campaign, how to get help, and clear description of how to opt-out. If you do not support opt-in via text, please leave this blank.
                        <span class="pointer" style="color: var(--primary-color);" (click)="op6.toggle($event)">Learn more</span>
                    </div>
                    <p-overlayPanel #op6>
                        <ng-template pTemplate>
                            <h6>Opt-in Message</h6>
                            <p>If users can text in a keyword, the response should include the Brand name, confirmation of opt-in enrollment to a recurring message campaign, how to get help, and clear description of how to opt-out.</p>
                            <h6 class="p-mb-0" style="font-size: 12px;">Successful Example:</h6>
                            <p>"You are successfully opted In for messages from ACME. Reply STOP to unsubscribe."</p>
                            <h6 class="p-mb-0" style="font-size: 12px;">Failure Example:</h6>
                            <p>
                                "You opted in for messages"
                                <br>(Opt-in message does not contain any information on brand and no information on opt-out process, campaign will be rejected.)
                            </p>
                        </ng-template>
                    </p-overlayPanel>
                </ng-container>
                <ng-container *ngIf="activePage == 8 && isConfirm">
                    <div class="bg-blue p-p-3 p-mb-5">
                        <div class="p-d-flex">
                            <span class="pi pi-info-circle"></span>
                            <div class="p-ml-2">
                                <h6>
                                    <i class="pi pi-spin pi-spinner"></i>
                                    A2P Campaign registration is in progress...</h6>
                                <p>
                                    <b>Your A2P Campaign has been submitted and is now under review. </b>
                                    This process may take several days to complete. The Twilio team will reach out via email if there's anything wrong with your campaign. Otherwise, you may check back on your campaign status in the "Campaigns" page in a couple of days.
                                    <br>Please note that until the campaign is approved, you will not be able to send A2P traffic on this campaign. In the meantime, you may proceed to the next page to pre-select the phone numbers you want to use for your campaign. Once your campaigns are approved, those phone numbers will be registered automatically.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-8">
                            <p-card class="review-card">
                                <h5>Campaign details</h5>
                                <div class="p-grid">
                                    <div class="p-col-6">
                                        <label><b>Connected A2P Brand</b></label>
                                        <p>LionOBytes Limited Liability Company</p>
                                    </div>
                                    <div class="p-col-6">
                                        <label><b>Campaign use case</b></label>
                                        <p>Low Volume Mixed</p>
                                    </div>
                                </div>
                                <div class="p-grid">
                                    <div class="p-col-6">
                                        <label><b>Campaign SID</b></label>
                                        <div class="p-d-flex">
                                            <div #campaignsid style="word-break: break-all;">CM6cb35200ce3ebb7d6b0906cac3df2f35</div>
                                            <span class="btnBars p-ml-1" (click)="copy(campaignsid)" style="margin-top: -0.5rem;">
                                                <i class="pi pi-copy"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="p-col-6">
                                        <label><b>Campaign status</b></label>
                                        <p>In progress</p>
                                    </div>
                                </div>
                                <div class="p-grid">
                                    <div class="p-col-6">
                                        <label><b>Linked Messaging Service</b></label>
                                        <div class="p-d-flex">
                                            <div #linkedms style="word-break: break-all;">MG31c87783bc968e0aa07be7cb71e2912c</div>
                                            <span class="btnBars p-ml-1" (click)="copy(linkedms)" style="margin-top: -0.5rem;">
                                                <i class="pi pi-copy"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="p-col-6">
                                        <label><b>External Campaign ID</b></label>
                                        <p>-</p>
                                    </div>
                                </div>
                                <div class="p-grid">
                                    <div class="p-col-6">
                                        <label><b>Brand registration SID</b></label>
                                        <div class="p-d-flex">
                                            <div #brandsid style="word-break: break-all;">BN3ee39840b5905e957fa9c3913547334d</div>
                                            <span class="btnBars p-ml-1" (click)="copy(brandsid)" style="margin-top: -0.5rem;">
                                                <i class="pi pi-copy"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </p-card>
                        </div>
                        <div class="p-col-4">
                            <p-card class="review-card">
                                <h5>Messaging throughput limits</h5>
                                <label><b>Campaign is under review.</b></label>
                                <p>This US A2P Campaign is under review, and may take 2-3 weeks to complete. After the registration process is complete, TCR (The Campaign Registry) will provide you with Campaign use case limits from relevant carriers.</p>
                            </p-card>
                        </div>
                    </div>
                    <p-card class="review-card">
                        <div class="p-d-flex">
                            <div class="icon-info">
                                <span class="fa fa-flag-o"></span>
                            </div>
                            <div class="p-grid">
                                <div class="p-col-12">
                                    <h6>Campaign Information</h6>
                                </div>
                                <div class="p-col-6">
                                    <label><b>Description</b></label>
                                    <p style="word-break: break-all;">dddddddddddddddddddddddddddddddddddddddddddddddddddddddd</p>
                                </div>
                                <div class="p-col-6">
                                    <label><b>Message Sample #1</b></label>
                                    <p style="word-break: break-all;">dfffffffffffffffffffffffffffffffffffffff</p>
                                </div>
                                <div class="p-col-6">
                                    <label><b>Sending messages with embedded links?</b></label>
                                    <p style="word-break: break-all;">No</p>
                                </div>
                                <div class="p-col-6">
                                    <label><b>Message Sample #2</b></label>
                                    <p style="word-break: break-all;">dfffffffffffffffffffffffffffffffffffffff</p>
                                </div>
                                <div class="p-col-6">
                                    <label><b>Sending messages with embedded phone numbers?</b></label>
                                    <p style="word-break: break-all;">No</p>
                                </div>
                            </div>
                        </div>
                    </p-card>
                    <p-card class="review-card">
                        <div class="p-d-flex">
                            <div class="icon-info">
                                <span class="fa fa-hand-paper-o"></span>
                            </div>
                            <div>
                                <div class="bg-blue p-p-3 p-mb-5">
                                    <div class="p-d-flex">
                                        <span class="pi pi-info-circle"></span>
                                        <div class="p-ml-2">
                                            <h6>Twilio manages opt-out and help keywords for you by default</h6>
                                            <p>
                                                Twilio manages opt-out and help keywords for you by default. We used this information to automatically fill out the details related to Opt Out and Help for your Campaign registration. If you want to customize these keywords and auto-reply messages, please go to
                                                <a style="color: var(--primary-color);" href="https://console.twilio.com/us1/service/sms/MG31c87783bc968e0aa07be7cb71e2912c/messaging-service-advanced-opt-out?frameUrl=%2Fconsole%2Fsms%2Fservices%2FMG31c87783bc968e0aa07be7cb71e2912c%2Fopt-out%3Fx-target-region%3Dus1" target="_blank">
                                                    Messaging Service - Opt-Out Management
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-grid">
                                    <div class="p-col-12">
                                        <label><b>How do end-users consent to receive messages?</b></label>
                                        <p>dddddddddddddddddddddddddddddddddddddddddddddddddddddddd</p>
                                    </div>
                                    <div class="p-col-6">
                                        <label><b>Opt-in Message</b></label>
                                        <p>-</p>
                                    </div>
                                    <div class="p-col-6">
                                        <label><b>Opt-in Keywords?</b></label>
                                        <p>-</p>
                                    </div>
                                </div>
                                <div class="p-grid">
                                    <div class="p-col-6">
                                        <label><b>Opt-out Message</b></label>
                                        <p style="word-break: break-all;">You have successfully been unsubscribed. You will not receive any more messages from this number. Reply START to resubscribe.</p>
                                    </div>
                                    <div class="p-col-6">
                                        <label><b>Opt-out Keywords</b></label>
                                        <div>
                                            <span *ngFor="let s of outkeywords" class="keyword">{{s.name}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-grid">
                                    <div class="p-col-6">
                                        <label><b>Help Message</b></label>
                                        <div>
                                            <span *ngFor="let s of helpkeywords" class="keyword">{{s.name}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-card>
                </ng-container>


                <ng-container *ngIf="activePage == 9">

                </ng-container>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" (click)="close()" class="p-button-secondary"></button>

        <button *ngIf="activePage == 1" pButton pRipple label="Next" (click)="activePage = 2;loadMenu();"></button>

        <button *ngIf="activePage==2 && !isEditInfo" pButton pRipple label="Back" (click)="activePage = 1;loadMenu();"></button>
        <button *ngIf="activePage==2 && !isEditInfo" pButton pRipple label="Next" (click)="activePage = 3;loadMenu();"
                [disabled]="customerProfileForm.get('businessDetails').invalid"></button>

        <button *ngIf="activePage == 3" pButton pRipple label="Back" (click)="activePage = 2;loadMenu();"></button>
        <button *ngIf="activePage == 3" pButton pRipple label="Next" (click)="activePage = 4;loadMenu();"
                [disabled]="customerProfileForm.get('businessAddress').invalid"></button>

        <button *ngIf="activePage == 4" pButton pRipple label="Back" (click)="activePage = 3;loadMenu();"></button>
        <button *ngIf="activePage == 4" pButton pRipple label="Next" (click)="activePage = 5;loadMenu();"
                [disabled]="authRepresentativeArray.invalid"></button>

        <button *ngIf="activePage == 5 && !isEditInfo && !isEditAddress && !isEditAuth" pButton pRipple label="Back" (click)="activePage = 4;loadMenu();"></button>
        <button *ngIf="activePage == 5 && !isEditInfo && !isEditAddress && !isEditAuth" pButton pRipple label="Submit" (click)="submitContactInformation()"></button>

        <button *ngIf="activePage == 6 && !isSubmitBrand" pButton pRipple label="Submit" (click)="isSubmitBrand=true;" [disabled]="!correctCheck"></button>
        <button *ngIf="activePage == 6 && isSubmitBrand" pButton pRipple label="Back" (click)="activePage = 5;loadMenu();"></button>
        <button *ngIf="activePage == 6 && isSubmitBrand" pButton pRipple label="Next" (click)="activePage = 7;loadMenu();"></button>

        <button *ngIf="activePage == 7" pButton pRipple label="Back" (click)="activePage = 6;loadMenu();"></button>
        <button *ngIf="activePage == 7" pButton pRipple label="Next" (click)="activePage = 8;loadMenu();"></button>

        <button *ngIf="activePage == 8 && !isConfirm" pButton pRipple label="Back" (click)="activePage = 7;loadMenu();"></button>
        <button *ngIf="activePage == 8 && !isConfirm" pButton pRipple label="Next" (click)="confirmRegistration()"></button>
        <button *ngIf="activePage == 8 && isConfirm" pButton pRipple label="Next" (click)="activePage = 9;loadMenu();"></button>

        <button *ngIf="isEditInfo || isEditAddress || isEditAuth" pButton pRipple label="Save and Continue" (click)="isEditInfo=false;isEditAddress=false;isEditAuth=false;activePage == 5"></button>

    </ng-template>
</p-dialog>

<p-dialog header="Messaging Service Unavailable" [(visible)]="displayMSError" [modal]="true" [style]="{width: '45vw'}">
    <div class="card">
        <p>This Messaging Service can't be used for new Campaign registration because it is already associated with another A2P Campaign</p>
        <p>Please choose a different Messaging Service or use the button below to delete the Campaign associated with the selected Messaging Service.</p>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" (click)="displayMSError=false" class="p-button-secondary"></button>
        <button pButton pRipple label="Delete Campaign"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Successful example" [(visible)]="displayExample" [modal]="true" [style]="{width: '45vw'}">
    <div class="card">
        <img [src]="assestBaseUrl + 'images/success_example.png'"  style="width:100%" alt="success example" />
    </div>
</p-dialog>

<p-dialog header="Confirm Campaign registration" [(visible)]="displayConfirm" [modal]="true" [style]="{width: '45vw'}">
    <div class="card">
        <p>Please confirm the following information for this A2P Campaign:</p>
        <ul>
            <li>I agree to paying the monthly <b>$1.50</b> to <b>$10</b> use case fee, as well as the A2P per message fees.
                <a class="p-ml-1" style="color: var(--primary-color);"
                href="https://support.twilio.com/hc/en-us/articles/1260803965530-What-pricing-and-fees-are-associated-with-the-A2P-10DLC-service-"
                target="_blank">
                   See all fees.
                </a>
            </li>
            <li>
                I understand that my Campaign will now go through manual reviews which result in a one-time <b>$15</b> vetting fee. I understand that until my Campaign is approved, my traffic will not be moved to registered A2P routes and will continue to experience higher filtering and fees.
                <a class="p-ml-1" style="color: var(--primary-color);"
                href="https://support.twilio.com/hc/en-us/articles/11587910480155-A2P-10DLC-Campaign-Vetting-FAQ"
                target="_blank">
                   Learn more about the vetting process.
                </a>
            </li>
            <li>
                I will be able to send the MPS allowed per Campaign to AT&T and 1 MPS per number to other US carriers.
                <a class="p-ml-1" style="color: var(--primary-color);"
                href="https://support.twilio.com/hc/en-us/articles/1260803225669-Message-throughput-MPS-and-Trust-Scores-for-A2P-10DLC-in-the-US"
                target="_blank">
                   Learn more about throughput.
                </a>
            </li>
            <li>
                I agree to the <a class="p-ml-1" style="color: var(--primary-color);"
                href="https://www.twilio.com/en-us/legal/messaging-policy"
                target="_blank">https://www.twilio.com/en-us/legal/messaging-policy</a>
            </li>
        </ul>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" (click)="displayConfirm=false" class="p-button-secondary"></button>
        <button pButton pRipple label="Confirm" (click)="confirm()"></button>
    </ng-template>
</p-dialog>
